import { DialogActions, DialogContent, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import DropZone from "../../../../commons/dropZone/DropZone";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import CharactersCounterLabel from "../../../../commons/labels/CharactersCounterLabel";
import solicitudReingresoFormValidation from "./solicitudReingresoValidations";

const SolicitudReingresoForm = ({ initialValues, handleSubmit, files, setFiles, handleCancel }) => {
  const loading = useSelector((state) => state.siniestralidad.cargarSolicitudReingreso.loading);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={solicitudReingresoFormValidation}
      enableReinitialize
    >
      {({ values }) => (
        <Form>
          <DialogContent fullWidth maxWidth="md">
            <Grid container>
              <Grid item xs={6} sx={{ padding: "15px" }}>
                <FormikTextField
                  name="siniestroART"
                  label="Nro Siniestro"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={6} sx={{ padding: "15px" }}>
                <FormikTextField
                  name="tipoSiniestro"
                  label="Tipo Siniestro"
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={6} sx={{ padding: "15px" }}>
                <FormikTextField
                  name="nroDocumento"
                  label="Número Documento"
                  fullWidth
                  disabled
                />
              </Grid>

              <Grid item xs={6} sx={{ padding: "15px" }}>
                <FormikTextField
                  name="apellidoNombre"
                  label="Apellido y Nombre"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item xs={12} sx={{ padding: "15px" }}>
                <FormikTextField
                  name="observaciones"
                  label="Observaciones*"
                  fullWidth
                  multiline
                  maxRows={10}
                  minRows={2}
                  variant="outlined"
                  disabled={loading}
                />
                <CharactersCounterLabel
                  value={values.observaciones}
                  maxCharacters={8000}
                />
              </Grid>
              <Grid item xs={12} sx={{ padding: "15px" }}>
                <DropZone
                  loading={loading}
                  file={files}
                  maxFiles={0}
                  setFile={setFiles}
                  colorearArchivosAdjuntos={true}
                  extension=".txt .pdf .jpg .png .xls .xlsx .docx"
                  accept={{
                    "text/plain": [".txt"],
                    "application/pdf": [".pdf"],
                    "image/jpeg": [".jpg"],
                    "image/png": [".png"],
                    "application/vnd.ms-excel": [".xls"],
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
                  }}
                  dropZoneText="Arrastre aquí, o haga click en el recuadro para importar archivos en formato .txt, .pdf, .jpg, .png, .xls, .xlsx o .docx."
                  dropZoneEditText="Si desea cambiar el archivo arrastrelo nuevamente o haga click en
    el recuadro."
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <FormikActions handleCancel={handleCancel} loading={loading} />
          </DialogActions>
        </Form>
      )}
    </Formik>
  );
}

export default SolicitudReingresoForm;
